import { connect } from 'react-redux';

import BasicModal from '@app/components/Modal/BasicModal';
import { editingDocumentSubmitRequest } from '@app/store/editingDocument/actions';
import { modalClose } from '@app/store/modal/actions';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClose: () => {
    dispatch(modalClose());
    dispatch(
      editingDocumentSubmitRequest({
        id: ownProps.id,
        inputs: ownProps.inputs,
      })
    );
  },
  onCancel: () => dispatch(modalClose()),
});

export default connect(null, mapDispatchToProps)(BasicModal);
